import React, { Component } from 'react';
import { connect } from 'react-redux';
import './TopNavigation.module.scss';
import {NavLink as NavLinkRouter} from 'react-router-dom';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUserCircle, faCog, faSignIn } from '@fortawesome/pro-solid-svg-icons';

import logoutUser from 'actions/authentication/logout';

const mapStateToProps = (state, props) => {
    return {
        user: state.authentication.user
    };
};

const mapDispatchToProps = {
    logoutUser
};

class TopNavigation extends Component {
    constructor() {
        super();

        this.logout = this.logout.bind(this);
    }

    logout() {
        this.props.logoutUser();
    }

    render() {
        // const buyButton = <a target="blank" href="https://www.studiotast.com/producten-bestellen">
            {/*<Button> Groow aanschaffen</Button>*/}
        // </a>;

        const NavLink = props => (
            <NavLinkRouter {...props} isActive={(match, location) => location.pathname.startsWith(props.to.pathname)}/>
        );

        return (
            <div styleName='container'>
                <div styleName='wrapper-right'>
                    {/* {isDemoUser() && buyButton } */}
                    <NavLink to='/accountinstellingen' styleName='button settings'>
                        <div styleName='avatar'>
                            <FontAwesomeIcon styleName="icon" icon={faUserCircle} size="3x" />
                        </div>
                        {/* <Avatar avatar={this.props.user.avatar_url} style ={{width: 40, height: 40, justifySelf:'center'}}/> */}
                        <h6> {this.props.user.first_name} {this.props.user.last_name}</h6>
                        <FontAwesomeIcon icon={faCog}/>
                    </NavLink>
                    {/* <a onClick={this.logout} styleName='button signout'> */}
                    <a onClick={this.logout} styleName='button-signout'>
                        {/* <button>Click</button> */}
                        <FontAwesomeIcon stylename='signout-icon' icon={faSignIn}/>
                    </a>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopNavigation);



// WEBPACK FOOTER //
// ./resources/assets/components/UI/TopNavigation/TopNavigation.jsx